import { AutogenModelOpenItemManual, AutogenRowOpenItemManual } from "./autogen/AutogenModelOpenItemManual";

export class ModelOpenItemManual extends AutogenModelOpenItemManual<RowOpenItemManual> {
	constructor() {
		super(RowOpenItemManual);
	}
}

export class RowOpenItemManual extends AutogenRowOpenItemManual {
}